import { styled, Popover as Popover$1, paperClasses } from "@mui/material";
import { monthCalendarClasses, pickersYearClasses, pickersMonthClasses } from "@mui/x-date-pickers";
const Container = styled("div")({});
const Popover = styled(Popover$1)(({ theme }) => ({
  [`& .${paperClasses.root}`]: {
    borderRadius: theme.spacing(2),
    boxShadow: theme.shadows[4]
  }
}));
Popover.defaultProps = {
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left"
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "left"
  },
  transitionDuration: 0,
  disablePortal: true
};
const DatePickerWrapper = styled("div")(() => ({
  [`& .${monthCalendarClasses.root}`]: {
    [`.${pickersYearClasses.root}, .${pickersMonthClasses.root}`]: {
      "&:after": {
        content: "unset"
      }
    }
  }
}));
export {
  Container,
  DatePickerWrapper,
  Popover
};
